import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ApiService } from '../api.service';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-order',
  templateUrl: './order.component.html',
  styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit, OnDestroy {
  dialogConfim = false;

  addresses: any;

  fields = [
    'Address_ThirdName',
    'Contact_Name',
    'Contact_FirstName',
    'Address_Address1',
    'Address_Address2',
    'Address_Address3',
    'Address_ZipCode',
    'Address_City',
  ];
  hiddenFields = [
    'Contact_Email',
    'Contact_Phone',
    'Contact_CellPhone',
    'Address_CountryIsoCode',
  ];

  addressChoosed: any;

  limitQtyById: any = {
    HIB046BL: 6,
    HIB047BL: 6,
    SPI019MI: 6,
    SPI020MI: 6,
    YAQ011CR: 6,
    YAQ012CR: 6,
    MAG011SK: 6,
    MAG012SK: 6
  };

  @Output() textAdded = new EventEmitter();

  lineTexts: any;

  now = Date.now();
  
  private orderSubscription!: Subscription;

  constructor(private router: Router, public api: ApiService) {}

  ngOnInit(): void {
    if (this.router.url == '/commande/fast') this.api.displayFast = true;

    this.lineTexts = this.api.texts.filter(
      (item) => item.discountRateSupp != undefined
    );
    if (this.lineTexts)
      this.lineTexts.push({ Id: 'sample', Caption: 'ECHANTILLON EXPORT' });

    if (this.api.adminOrder) {
      // Défaut toujours "Commande" (nouvelle commande et modif de devis)
      this.api.order.devis = false;
      this.api.order.createBy =
        this.api.order.createBy != undefined ? this.api.order.createBy : 'brg';
    } else {
      this.api.order.createBy = 'other';
    }
    
    // Vérifier les limites de quantités au chargement
    this.api.revalidateCartAvailability();
    this.checkQuantityLimits();
    
    // S'abonner aux changements de commande
    this.orderSubscription = this.api.orderChange$.subscribe(() => {
      this.checkQuantityLimits();
    });
    //console.log(this.api.order);
  }
  
  ngOnDestroy(): void {
    if (this.orderSubscription) {
      this.orderSubscription.unsubscribe();
    }
  }  
  
  refresh() {
    this.api
      .postWS('sql=select', {
        fields: '*',
        database: 'Customer',
        where: "Id = '" + this.api.user.Id + "'",
      })
      .then((res: any) => {
        const addresses = [];
        let address = '';
        for (let f of this.fields) {
          address +=
            res[0]['MainDelivery' + f] != null &&
            res[0][f.replace('_', 'Fields_')] != ''
              ? f == 'Contact_Name' ||
                f == 'Address_ZipCode' ||
                f == 'Address_City'
                ? res[0]['MainDelivery' + f] + ' '
                : res[0]['MainDelivery' + f] + ', '
              : '';
        }
        addresses.push({ value: 0, label: address.trim() });
        this.api
          .postWS('sql=select', {
            fields: '*',
            database: 'Contact',
            where:
              "AssociatedCustomerId = '" +
              this.api.user.Id +
              "' AND IsMainInvoicing = 0 AND IsMainDelivery = 0",
          })
          .then((res2: any) => {
            for (let a of res2) {
              let address = '';
              for (let f of this.fields) {
                address +=
                  a[f.replace('_', 'Fields_')] != null &&
                  a[f.replace('_', 'Fields_')] != ''
                    ? f == 'Contact_Name' ||
                      f == 'Address_ZipCode' ||
                      f == 'Address_City'
                      ? a[f.replace('_', 'Fields_')] + ' '
                      : a[f.replace('_', 'Fields_')] + ', '
                    : '';
              }
              addresses.push({ value: a.Id, label: address, address: a });
            }
            this.addresses = addresses;
            this.addressChoosed = 0;
          });
      });
  }

  send() {
    // Vérification côté client avant envoi
    if (this.hasAnyQuantityLimitExceeded()) {
      this.api.error('Impossible de valider la commande : certains produits dépassent la quantité maximale autorisée.');
      return;
    }

    if (this.isDotationRequired() && !this.api.order.dotation) {
      this.api.error('Veuillez sélectionner une Dotation (brg ou editeur) avant de valider la commande.');
      this.dialogConfim = false;
      return;
    }

    if (this.api.order.prods.length === 0) {
      this.api.error('Impossible de valider une commande vide.');
      return;
    }

    const unavailable = this.api.revalidateCartAvailability();
    if (unavailable.length > 0 && !this.api.adminOrder) {
      const names = unavailable.map((p) => p.name || p.Id).join(', ');
      this.api.error(
        'Impossible de valider : articles indisponibles (' + names + '). Retirez-les du panier.'
      );
      this.dialogConfim = false;
      return;
    }

    if (!this.api.isDevMode() && this.api.order.sumTTC < 100 && !this.api.adminOrder) {
      this.api.error('Le montant minimal de commande est de 100 €.');
      return;
    }

    this.api.order.addressChanged = false;
    if (this.addressChoosed != 0) {
      //this.api.order.addressChanged = true;
      this.api.order.deliveryAddress = {};
      let a = this.addresses.find((item) => item.value == this.addressChoosed);
      for (let f of this.fields.concat(this.hiddenFields)) {
        this.api.order.deliveryAddress['MainDelivery' + f] =
          a.address[f.replace('_', 'Fields_')];
      }
    }

    if (this.api.adminOrder && this.api.adminUser) {
      this.api.order.ColleagueId = this.api.adminUser.value.ebp_id;
      this.api.order.ColleagueEmail = this.api.adminUser.value.email;
    } else {
      this.api.order.ColleagueId = this.api.user.ColleagueId;
      this.api.order.ColleagueEmail = this.api.user.ColleagueEmail;
    }

    // Garde : uniquement si on est explicitement en édition de devis
    if (
      this.api.adminOrder &&
      this.api.order.edit === true &&
      !this.api.order.DocumentNumber
    ) {
      this.api.error(
        'Édition de devis incohérente (DocumentNumber manquant). Rechargez le devis depuis la liste.'
      );
      this.dialogConfim = false;
      return;
    }

    // console.log('postOrder', {
    //   edit: this.api.order.edit,
    //   devis: this.api.order.devis,
    //   DocumentNumber: this.api.order.DocumentNumber,
    //   ref: this.api.order.ref,
    // });

    //remove prod for OFFERS
    for (let i in this.api.order.prods) {
    }

    this.api.postOrder(this.api.order).then((res) => {
      this.api.success(
        "Votre commande est enregistrée. Vous la retrouverez d'ici quelques minutes dans 'mes commandes'"
      );
      localStorage.removeItem('brgProOrder');

      for (let p of this.api.order.prods) {
        p.quantity = 0;
        this.api.changeQty(p);
      }
      if (!this.api.adminOrder) this.api.goTo('mes-commandes');
      else window.location.reload();
    });
  }

  isDotationRequired() {
    const user = this.api.adminUser && this.api.adminUser.value;
    return !!(this.api.adminOrder && user && String(user.profil) === '9');
  }

  saveOrder() {
    if (this.api.adminOrder && this.api.adminUser) {
      this.api.order.ColleagueId = this.api.adminUser.value.ebp_id;
      this.api.order.ColleagueEmail = this.api.adminUser.value.email;
    }

    let post = {
      CustomerId: this.api.user.Id,
      order_json: JSON.stringify(this.api.order),
      adminOrder: this.api.adminOrder ? 1 : 0,
    };
    this.api
      .post('SPDO=insert', { database: 'pro_order', data: post })
      .then((res: any) => {
        this.api.success('Votre commande a bien été sauvegardée');
        localStorage.removeItem('brgProOrder');
        this.api.order = this.api.newOrder;
        this.api.order.customer = this.api.user;
      });
  }

  duplicate(prod) {
    let copy = Object.assign({}, prod);
    copy.id = prod.id + 1;
    delete copy.offerId;
    delete copy.qtyToDelete;
    delete copy.offerName;
    delete copy.id_offer;
    copy.parent = prod.id;
    copy.duplicate = true;
    copy.quantity = 1;
    this.api.order.prods.push(copy);
    this.api.totalOrder();
  }

  onFileChoose(event) {
    const reader = new FileReader();
    reader.onload = (e) => {
      let text = e.target.result as string;
      let rows = text.split('\n');
      for (let row of rows) {
        let data = row.split(';');
        let game = this.api.games.find(
          (item) => item.Id == data[0].trim() || item.BarCode == data[0].trim()
        );
        if (
          game &&
          game.xx_Disponible_pour_la_vente == '1' &&
          game.rupture != true
        ) {
          if (data[1] && data[1] != null && data[1] != '') {
            game.quantity = parseInt(data[1].trim());
            if (game.quantity > 0) {
              setTimeout(() => {
                this.api.addToCart(game, true);
              }, 300);
            }
          }
        }
      }
    };
    reader.readAsText(event.currentFiles[0]);
  }

  async fastOrder() {
    console.log(this.api.fastOrderQty);
    const ids = Object.keys(this.api.fastOrderQty);

    for (let i = 0; i < ids.length; i++) {
      const Id = ids[i];

      // Ajouter un délai de 100ms entre chaque itération
      if (i > 0) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }

      let gameInCart = this.api.order.prods.find(
        (item) => item.id === this.api.fastOrderQty[Id].idInCart
      );
      if (!gameInCart) {
        if (
          this.api.fastOrderQty[Id].qtyInCart > 0 &&
          this.api.fastOrderQty[Id].ItemType == '0'
        ) {
          this.api.addToCart(this.api.fastOrderQty[Id]);
        }
        if (
          this.api.fastOrderQty[Id].qtyInCart > 0 &&
          this.api.fastOrderQty[Id].ItemType == '1'
        ) {
          let offer = this.api.ebpOffers.find(
            (item) => item.Id == this.api.fastOrderQty[Id].Id
          );
          if (offer) {
            this.api.addEbpOffer(offer);
          } else {
            this.api.addToCart(this.api.fastOrderQty[Id]);
          }
        }
      } else {
        if(gameInCart.quantity !== this.api.fastOrderQty[Id].qtyInCart){
          gameInCart.quantity = this.api.fastOrderQty[Id].qtyInCart;
          this.api.changeQty(gameInCart);
        }
      }
    }
  }

  /**
   * Vérifie les limites de quantité et marque les produits concernés
   * Prend en compte la possibilité d'avoir plusieurs lignes avec le même ID de produit
   */
  checkQuantityLimits(): void {
    if (!this.api.order.prods || this.api.order.prods.length === 0) {
      return;
    }

    // Grouper les produits par ID et calculer la quantité totale
    const quantityByProductId: { [key: string]: number } = {};

    this.api.order.prods.forEach((prod) => {
      const productId = prod.Id || prod.id;
      if (productId) {
        if (!quantityByProductId[productId]) {
          quantityByProductId[productId] = 0;
        }
        quantityByProductId[productId] += prod.quantity || 0;
      }
    });

    // Marquer les produits qui dépassent les limites
    this.api.order.prods.forEach((prod) => {
      const productId = prod.Id || prod.id;
      if (productId && this.limitQtyById[productId]) {
        const totalQty = quantityByProductId[productId];
        const maxQty = this.limitQtyById[productId];
        
        if (totalQty > maxQty) {
          prod.hasLimitedQty = true;
          prod.limitMessage = `Limite dépassée ! Maximum autorisé : ${maxQty} (Total actuel : ${totalQty})`;
        } else {
          prod.hasLimitedQty = false;
          prod.limitMessage = '';
        }
      }
    });
  }

  /**
   * Vérifie si une limite de quantité est dépassée pour au moins un produit
   */
  hasAnyQuantityLimitExceeded(): boolean {
    return this.api.order.prods.some((prod) => prod.hasLimitedQty === true);
  }

  hasUnavailableProducts(): boolean {
    return this.api.order.prods.some(
      (prod) => prod.type != 'text' && !prod.gift && prod.rupture === true
    );
  }
}
